module.exports = __webpack_public_path__ + "img/fhir4pharma_logo.8613fc43.png";